// @flow
import React from "react";
import PageContainer from "../containers/PageContainer";
import ForgotPasswordForm from "../containers/ForgotPasswordForm";
import { useTranslation } from 'react-i18next';

export default function ForgotPasswordView() {
    const { t } = useTranslation();
  return (
      <PageContainer title={t("Forgot Password")} showShopToolbar={false}>
          <ForgotPasswordForm />
    </PageContainer>
  );
}
